<template>
    <a-card>
        <a-row type="flex" justify="start" class="icons-list">
            <a-col :flex="3" justify="center" v-show="isConnected">
                <a-icon type="cloud" />
            </a-col>
            <a-col :flex="3" justify="center" v-show="!isConnected">
                <a-icon type="disconnect" />
            </a-col>
            <a-col :flex="3" justify="center">
                <p v-show="isConnected">Connected</p>
                <p v-show="!isConnected">Disconnected</p>
            </a-col> 
        </a-row>
        <br>
        <a-row type="flex" justify="start" class="icons-list">
            <a-col :flex="3" justify="center">
                <a-progress :percent="100" v-show="isConnected"/>   
                <a-progress :percent="0" status="exception" v-show="!isConnected"/>  
            </a-col>
        </a-row>
    </a-card>
</template>

<script>
import { mapState } from 'vuex';
export default {
    computed : {
        ...mapState({
            isConnected : state => state.hub.isConnected
        })
    }
}
</script>

<style scoped>
.icons-list >>> .anticon {
  margin-right: 6px;
  font-size: 24px;
}
</style>
